export default __webpack_public_path__ + "static/gabriel_marcos-d2bbab8f4be113858d5fcd9f2a31bf1c.jpg";